import React from "react";
import styles from "./journey-event-info.module.css";
import StandardRewardRow from "./standard-reward-row";
import getImageFileName from "../../functions/getImageFileName";
import { getJourneyTimeString } from "../../functions/stringFunctions";
import { getUIText } from "../../translation";
import { JOURNEY_STATUS_KEY_TYPE, LOCALES } from "../../constants";

export default function JourneyEventInfo({ lang, journey, difficultyFilter }) {
    const hasChoices = journey.variants[0].choices.length > 1 || journey.variants[0].choices[0].name !== "";

    const filteredVariants = journey.variants.filter((variant) => {
        if (difficultyFilter.value === "all" || !variant.difficulties) return true;
        return variant.difficulties.some((d) => d[LOCALES.EN].toLowerCase() === difficultyFilter.value);
    });

    return (
        <div className={styles["event"]}>
            <div className={styles["event-name"]}>{journey.name[lang]}</div>
            {journey.times && (
                <div className={styles["event-conditions"]}>
                    {journey.times.length > 0 &&
                        journey.times.map((time) => {
                            return (
                                <span className={`${styles["condition"]} ${styles["time"]}`} key={`${journey.name[lang]}_${time}`}>
                                    {getJourneyTimeString(lang, time)}
                                </span>
                            );
                        })}
                </div>
            )}
            <div className={styles["choices"]}>
                {/* 보상 */}
                {journey.variants[0].choices.map((choice, choiceIndex) => {
                    return (
                        <div className={styles["choice"]} key={`${journey.name[lang]}_${choiceIndex}`}>
                            {/* 이름+조건 */}
                            <div className={styles["choice-header"]}>
                                {choice.name && (
                                    <span className={styles["choice-name"]}>
                                        {hasChoices ? `${choiceIndex + 1}. ${choice.name[lang]}` : `${choice.name[lang]}`}
                                    </span>
                                )}
                            </div>
                            {/* 보상 */}
                            <div className={styles["rewards"]}>
                                {choice.success_rewards.length > 0 && (
                                    <div className={`${styles["reward-wrapper"]}`}>
                                        {filteredVariants.map((variant, variantIndex) => {
                                            const choice = variant.choices[choiceIndex];

                                            return (
                                                <div
                                                    className={styles["reward-group"]}
                                                    key={`${journey.name}_${choiceIndex}_${variantIndex}`}
                                                >
                                                    {(variant.difficulties || choice.condition) && (
                                                        <div className={styles["choice-condition"]}>
                                                            {variant.difficulties &&
                                                                variant.difficulties.map((difficulty) => (
                                                                    <div
                                                                        className={`${styles["badge"]} ${styles[difficulty[LOCALES.EN]]}`}
                                                                        key={`${journey.name}_${choiceIndex}_difficulty_${difficulty[lang]}`}
                                                                    >
                                                                        {difficulty[lang]}
                                                                    </div>
                                                                ))}
                                                            {variant.battleNames && (
                                                                <div
                                                                    className={`${styles["badge"]} ${styles[variant.difficulties?.at(-1)?.[LOCALES.EN] ?? "normal"]}`}
                                                                >
                                                                    {variant.battleNames.map((e) => e[lang]).join(", ")}
                                                                </div>
                                                            )}
                                                            {choice.condition && (
                                                                <div className={`${styles["badge"]} ${styles["item"]}`}>
                                                                    {choice.condition.type === "RR_STAT" &&
                                                                        `${JOURNEY_STATUS_KEY_TYPE[choice.condition.target][lang]} ${choice.condition.value} ${getUIText(lang, "journey.event.condition.needed")}`}
                                                                    {choice.condition.type === "RR_STAMINA_USE" &&
                                                                        `${getUIText(lang, "journey.event.condition.useStamina")} ${choice.condition.value}`}
                                                                    {choice.condition.type === "RR_ITEM_CHECK" && (
                                                                        <div>
                                                                            <img
                                                                                src={`${process.env.PUBLIC_URL}/images/item/${getImageFileName(choice.condition.item.name[LOCALES.KO])}.webp`}
                                                                            />
                                                                            {lang === LOCALES.KO
                                                                                ? `${choice.condition.item.name[lang]} 보유`
                                                                                : `Have ${choice.condition.item.name[lang]}`}
                                                                        </div>
                                                                    )}
                                                                    {choice.condition.type === "RR_ITEM_USE" && (
                                                                        <div>
                                                                            <img
                                                                                src={`${process.env.PUBLIC_URL}/images/item/${getImageFileName(choice.condition.item.name[LOCALES.KO])}.webp`}
                                                                            />
                                                                            {lang === LOCALES.KO
                                                                                ? `${choice.condition.item.name[lang]} 소모`
                                                                                : `Use ${choice.condition.item.name[lang]}`}
                                                                        </div>
                                                                    )}
                                                                    {choice.condition.type === "RR_COIN_USE" &&
                                                                        `${getUIText(lang, "journey.event.condition.useCoin")} ${choice.condition.value}`}
                                                                    {choice.condition.type === "RR_PP_USE" &&
                                                                        `${getUIText(lang, "journey.event.condition.usePotentialPoint")}  ${choice.condition.value}`}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    <div
                                                        className={`${styles["success-rewards"]} ${!choice.failure_rewards ? styles["only"] : ""}`}
                                                    >
                                                        {choice.success_rewards.map((reward, rewardIndex) => {
                                                            return (
                                                                <StandardRewardRow
                                                                    lang={lang}
                                                                    reward={reward}
                                                                    difficulty={variant.difficulties ? variant.difficulties[0] : ""}
                                                                    reward_flag={"success"}
                                                                    key={`${journey.name}_${choiceIndex}_success_${variantIndex}_${rewardIndex}`}
                                                                />
                                                            );
                                                        })}
                                                    </div>
                                                    {choice.failure_rewards && (
                                                        <div className={styles["failure-rewards"]}>
                                                            {choice.failure_rewards.length === 0 &&
                                                                getUIText(lang, "journey.event.reward.none")}
                                                            {choice.failure_rewards.length > 0 &&
                                                                choice.failure_rewards.map((reward, rewardIndex) => {
                                                                    return (
                                                                        <StandardRewardRow
                                                                            lang={lang}
                                                                            reward={reward}
                                                                            difficulty={variant.difficulties ? variant.difficulties[0] : ""}
                                                                            reward_flag={"fail"}
                                                                            key={`${journey.name}_${choiceIndex}_fail_${variantIndex}_${rewardIndex}`}
                                                                        />
                                                                    );
                                                                })}
                                                        </div>
                                                    )}
                                                    {variantIndex < filteredVariants.length - 1 && (
                                                        <div className={styles["group-divider"]}>
                                                            <span className={styles["success"]}>or</span>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                                {choice.success_rewards.length === 0 && (
                                    <div className={styles["reward-wrapper"]}>{getUIText(lang, "journey.event.reward.none")}</div>
                                )}
                                {/* {choice.failure_rewards.length > 0 && (
                                    <div className={`${styles["reward-wrapper"]} ${styles["fail"]}`}>
                                        {journey.variants.map((variant, variantIndex) => {
                                            const choice = variant.choices[choiceIndex];

                                            return (
                                                <div
                                                    className={styles["reward-group"]}
                                                    key={`${journey.name}_${choiceIndex}_fail_${variantIndex}`}
                                                >
                                                    {(variant.difficultyEng || choice.condition) && (
                                                        <div className={styles["choice-condition"]}>
                                                            {variant.difficultyEng && (
                                                                <div className={`${styles["badge"]} ${styles[variant.difficultyEng]}`}>
                                                                    {variant.difficultyKor}
                                                                </div>
                                                            )}
                                                            {choice.condition && (
                                                                <div className={`${styles["badge"]} ${styles["item"]}`}>
                                                                    {choice.condition.type === "스탯" &&
                                                                        `${choice.condition.target} ${choice.condition.value} 필요`}
                                                                    {choice.condition.type === "스태미나 소모" &&
                                                                        `스태미나 ${choice.condition.value} 소모`}
                                                                    {choice.condition.type === "아이템 보유" && (
                                                                        <div>
                                                                            <img
                                                                                src={`${process.env.PUBLIC_URL}/images/item/${choice.condition.item.name}.webp`}
                                                                            />
                                                                            {`${choice.condition.item.name} 보유`}
                                                                        </div>
                                                                    )}
                                                                    {choice.condition.type === "아이템 소모" && (
                                                                        <div>
                                                                            <img
                                                                                src={`${process.env.PUBLIC_URL}/images/item/${choice.condition.item.name}.webp`}
                                                                            />
                                                                            {`${choice.condition.item.name} 소모`}
                                                                        </div>
                                                                    )}
                                                                    {choice.condition.type === "오래된 주화 소모" &&
                                                                        `오래된 주화 ${choice.condition.value} 소모`}
                                                                    {choice.condition.type === "잠재력 포인트 소모" &&
                                                                        `잠재력 포인트 ${choice.condition.value} 소모`}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    {choice.failure_rewards.map((reward, rewardIndex) => {
                                                        return (
                                                            <StandardRewardRow
                                                                reward={reward}
                                                                difficulty={variant.difficultyKor}
                                                                reward_flag={"fail"}
                                                                key={`${journey.name}_${choiceIndex}_fail_${variantIndex}_${rewardIndex}`}
                                                            />
                                                        );
                                                    })}
                                                    {variantIndex < journey.variants.length - 1 && (
                                                        <div className={styles["group-divider"]}>
                                                            <span>or</span>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )} */}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
